import webApiAdmin from '@/lib/api-common/webApiAdmin';

export type LabelKind = 'game' | 'genre' | 'category' | 'theme' | 'platform' | string;

export interface LabelItem {
  _id?: string;
  id?: string;
  title: string;
  type?: LabelKind;
  aliases?: string[];
  platforms?: string[];
  isFavorite?: boolean;
  isHidden?: boolean;
  unimportant?: boolean;
}

export interface AddGameResponse {
  text?: string;
}

export interface SearchGameResult {
  game?: string;
  key?: string;
  youtubeCount?: number;
  twitchChannels?: number;
  twitchViewers?: number;
  [key: string]: unknown;
}

/**
 * List labels.
 * - Legacy: GET /api3/labels/getLabels
 * - New:    GET /admin/labels/get-labels
 */
export async function getLabels(): Promise<LabelItem[]> {
  const data = await webApiAdmin.get<LabelItem[]>('admin/labels/get-labels');
  return Array.isArray(data) ? data : [];
}

/**
 * List games.
 * - Legacy: POST /api3/labels/getGames
 * - New:    POST /admin/labels/get-games
 */
export async function getGames(): Promise<LabelItem[]> {
  const data = await webApiAdmin.post<LabelItem[]>('admin/labels/get-games', {});
  return Array.isArray(data) ? data : [];
}

/**
 * Toggle favorite on a label.
 * - Legacy: POST /api3/labels/favoriteLabel
 * - New:    POST /admin/labels/favorite-label
 */
export async function favoriteLabel(params: {
  labelId: string;
  isFavorite: boolean;
  type: LabelKind;
}): Promise<void> {
  await webApiAdmin.post('admin/labels/favorite-label', params);
}

/**
 * Toggle hidden on a label.
 * - Legacy: POST /api3/labels/hideLabel
 * - New:    POST /admin/labels/hide-label
 */
export async function hideLabel(params: {
  labelId: string;
  isHidden: boolean;
  type: LabelKind;
}): Promise<void> {
  await webApiAdmin.post('admin/labels/hide-label', params);
}

/**
 * Add a game by URL.
 * - Legacy: POST /api3/labels/addGame
 * - New:    POST /admin/labels/add-game
 */
export async function addGame(url: string): Promise<AddGameResponse> {
  const response = await webApiAdmin.post<AddGameResponse>('admin/labels/add-game', { url });
  return response ?? {};
}

/**
 * Search a game (external counts).
 * - Legacy: POST /api3/labels/searchGame
 * - New:    POST /admin/labels/search-game
 */
export async function searchGame(game: string): Promise<SearchGameResult> {
  const result = await webApiAdmin.post<SearchGameResult>('admin/labels/search-game', { game });
  return result ?? {};
}
